/// <reference path="./download.d.ts" />

window.onload = () => {
	const userAgent = navigator.userAgent
	const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1
	const isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
	const isWeChat = !!userAgent.match(/MicroMessenger/i)

	let link = ANDROID_LINK || ""

	if (isWeChat) {

	} else if (isiOS) {
		link = IOS_LINK
	}
	
	const downloadBtns = document.querySelectorAll(".head-reserve-btn")
	downloadBtns.forEach((ele: HTMLElement) => {
		ele.addEventListener("click", (event) => {
			window.location.href = link
		})
	})
}